export default function bulkDeleteReportInstanceDirective() {
  return {
    template: require('./bulk-delete-report-instance.html'),
    restrict: 'E',
    controller: 'BulkDeleteReportInstanceController',
    controllerAs: 'bulkDeleteReportInstanceVM',
    bindToController: true,
    replace: true,
    scope: {
      reportInstance: '=',
    },
  };
}
